<script>
export default {
  name: 'MessageItem',
  props: {
    message: Object,
    orderIdPublic: String,
    userIdPublic: String,
    internalView: Boolean,
    editionLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      messageEditVisible: false,
      isInternal: this.message.isInternal,
      isCurrentUser: this.message.isCurrentUser,
      messageContent: this.message.message,
    };
  },
  methods: {
    editButtonClick() {
      this.messageEditVisible = !this.messageEditVisible;

      if (this.messageEditVisible) {
        this.$nextTick(() => this.$refs.editmessagetextarea.focus());
      } else {
        this.messageContent = this.message.message;
      }
    },
    editMessage() {
      let payload = {
        idPublic: this.message.idPublic,
        message: this.messageContent,
        isInternal: this.isInternal,
      };

      this.$emit('update-message', payload);

      this.messageEditVisible = false;
    },
  },
};
</script>

<template>
  <div
    class="ml-1 mr-1 mb-2 rounded"
    :class="
      isCurrentUser && isInternal
        ? 'bg-secondary'
        : isCurrentUser
        ? 'bg-primary'
        : isInternal
        ? 'bg-secondary'
        : 'bg-warning'
    "
  >
    <div
      class="d-flex justify-content-between text-white pl-2 pt-2"
      style="white-space: nowrap"
    >
      <b>{{ message.userName }}</b>
      <b v-if="isInternal" class="flex-fill font-weight-light pl-1">
        | {{ $t('messages.internalMessage') }}
      </b>
      <span class="badge pl-1 pr-2 text-white" style="font-size: 1em">
        {{ message.date }}
      </span>
    </div>
    <div
      class="d-flex justify-content-between position-relative text-white"
      style="white-space: nowrap"
    >
      <div
        v-if="!messageEditVisible"
        class="mt-1 text-white pl-2 pr-2 pb-2"
        style="white-space: pre-line"
      >
        {{ message.message }}
      </div>
      <div class="container" v-if="messageEditVisible">
        <div class="col">
          <div class="row">
            <textarea
              ref="editmessagetextarea"
              class="mt-1 mb-2 pr-2 pb-2 rounded"
              @keydown.enter.ctrl.exact.prevent="editMessage"
              @keydown.escape.exact.prevent="editButtonClick"
              rows="6"
              style="width: 100%"
              v-model="messageContent"
            />
          </div>
          <div class="row pb-2" style="white-space: nowrap">
            <b-button variant="info" @click="editMessage">
              {{ $t('messages.editMessage') }}
            </b-button>
            <b-form-checkbox
              v-if="internalView"
              class="flex-push"
              v-model="isInternal"
              name="checkbox-is-internal"
            >
              {{ $t('messages.internalMessage') }}
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <span
        v-if="isCurrentUser"
        class="d-flex flex-wrap align-content-end pr-2 pb-2"
      >
        <i
          v-if="!editionLoading"
          @click="editButtonClick"
          class="fa fa-pen"
          aria-hidden="true"
          style="color: white; cursor: pointer"
        ></i>
        <i
          v-else
          class="fas fa-spinner fa-spin"
          style="font-size: 1.3em; color: white"
        ></i>
      </span>
    </div>
  </div>
</template>